<template>
    <div>
      <div class="col-md-3 col-xs-12">
        <va-small-box
          class="info-box box-blue"
          icon="ion-briefcase "
          :title="totalCollectionAmt"
          description="Total Collection Amount"
          @more-click="clickToSmallBox"
          moreText="More info">
        </va-small-box>
      </div>
    </div>
</template>
<script>
import VASmallBox from '../widgets/VASmallBox.vue'
export default {
  props: ['message'],
  data () {
    return {
      totalCollection: 0,
      totalInterest: 0
    }
  },
  computed: {
    totalCollectionAmt () {
      if (this.message[0]) {
        this.totalCollection = this.message[0].totalCollection
      }
      return this.totalCollection
    }
  },
  methods: {
    clickToSmallBox () {
      this.$router.push({name: 'showCollection'})
    }
  },

  components: {
    'va-small-box': VASmallBox
  }
}
</script>
<style >
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-blue {
    background-color:#003c60;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// totalcollection.vue?b1bf82a4